import React from 'react'
import ProfilingFlow from '../components/profiling/ProfilingFlow'
import { Box } from '@mui/material'
import { useParams, useSearchParams } from 'react-router-dom'

const Profilling = () => {
  const { kidId } = useParams();
  const [searchParams] = useSearchParams();
  const exam = searchParams.get('exam'); // 'pedagogical' | 'neuro' | null

  return (
    <Box className="mobile-app-container" sx={{ bgcolor: '#FFF7E5', minHeight: '100vh' }}>
      <ProfilingFlow kidId={kidId} exam={exam} />
    </Box>
  )
}

export default Profilling
